import { Injectable } from '@angular/core';
import swal from 'sweetalert2';
import { Router } from '@angular/router';
import { SwalStyle } from './swalStyle';

@Injectable()
export class NotificationService implements
  NotificationSuccess, NotificationError, NotificationAlert, NotificationInfo, NotificationQuestion, LoadingModel {

  style: SwalStyle = new SwalStyle();

  openLoading(options?: object) {
    const properties = Object.assign({
      imageUrl: 'assets/images/loading.gif', imageHeight: 40, showConfirmButton: false, allowOutsideClick: false },
    this.style.getLoading(),
    options);
    return swal(properties);
  }

  closeLoading() {
    swal.close();
  }


  showQuestionNotification(msg: string, options?: object): Promise<any> {
    const properties = Object.assign(
      {
        title: '',
        text: msg,
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        reverseButtons: true
      },
      this.style.getGeneralStyle(),
      this.style.getQuestionStyle(),
      options
    );
    return swal(properties);
  }
  showInfoNotification(msg: string, options?: object): Promise<any> {
    const properties = Object.assign(
      { title: 'Informação!', text: msg},
      this.style.getGeneralStyle(),
       options);
    return swal(properties);
  }
  showAlertNotification(msg: string, options?: object): Promise<any> {
    const properties = Object.assign({ title: 'Atenção!', text: msg}, {'confirmButtonColor' : '#f6901c'}, options);
    return swal(properties);
  }
  showErrorNotification(msg: string, options?: object): Promise<any> {
    const properties = Object.assign({ title: 'Erro!', text: msg}, this.style.getGeneralStyle(), this.style.getErrorStyle(), options);
    return swal(properties);
  }
  showSuccessNotification(msg: string, options?: object): Promise<any> {
    const properties = Object.assign({ title: 'Sucesso!', text: msg}, this.style.getGeneralStyle(), options);
    return swal(properties);
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/notification/swal/notification.service.ts